import {PRIMARY_OUTLET, Router} from '@angular/router';

export function getLinkResourceId(value: string | null | undefined): number | undefined {
  if (!value || !/^\d+$/.test(value)) return undefined;
  const id = Number(value);
  return Number.isSafeInteger(id) && id > 0 ? id : undefined;
}

export function getLinkRedirect(router: Router, redirect: string | null | undefined, resourceId: number): string | undefined {
  if (!redirect?.startsWith(`/link/${resourceId}/`)) return undefined;
  const tree = router.parseUrl(redirect);
  const segments = tree.root.children[PRIMARY_OUTLET]?.segments;
  if (segments?.[0]?.path !== 'link' || segments[1]?.path !== String(resourceId)) return undefined;
  delete tree.queryParams['key'];
  return router.serializeUrl(tree);
}
